import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getTypePositionsActionAsync } from '../redux/actions/typePositionActions'

export const useTypePosition = () => {
  const { typePositionsState } = useSelector(
    (state: RootState) => state.typePosition
  )
  const dispatch = useDispatch()

  const getTypePositions = () => {
    dispatch(getTypePositionsActionAsync())
  }

  return { typePositionsState, getTypePositions }
}
